import { ReactNode } from 'react';
import { Container, Typography } from '@mui/material';
import { BookingCaseContextProvider } from './BookingCaseContext';

interface Props {
  title: string;
  intro: string;
  children: ReactNode;
}

/**
 * Marco común de los verticales de Rutero. El ancho no depende de cuántos
 * campos tenga cada buscador: encabezado, barra y resultados comparten los
 * mismos bordes visuales en todas las páginas.
 */
export function TravelServicesPage({ title, intro, children }: Props) {
  return (
    <Container
      maxWidth={false}
      sx={{
        width: '100%',
        maxWidth: 1320,
        py: { xs: 2.5, md: 4 },
        px: { xs: 2, sm: 3 },
      }}
    >
      <Typography variant="h5">{title}</Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        {intro}
      </Typography>
      <BookingCaseContextProvider>{children}</BookingCaseContextProvider>
    </Container>
  );
}
